class NSSPDPIngredients extends HTMLElement {

  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][PDP Ingredients] Connected.");

    this.addEventListener(`click`, this.processClick.bind(this));
    this.addEventListener("pdpUpdate", this.updateContent.bind(this));
  }

  processClick(e) {
    if (this.debug) console.log(`[NSS][PDP Ingredients] Clicked:`, e.target);

    if (e.target.hasAttribute(`nss-ingredient-item`)) {
      if (e.target.classList.contains(`nss-active`)) {
        e.target.classList.remove(`nss-active`);
      } else {
        this.closeAllIngredients();
        e.target.classList.add(`nss-active`);
      }
    }

    if (e.target.hasAttribute(`nss-nutrition-facts-btn`)) {
      if (e.target.parentElement.classList.contains(`nss-facts-active`)) {
        e.target.parentElement.classList.remove(`nss-facts-active`);
      } else {
        e.target.parentElement.classList.add(`nss-facts-active`);
      }
    }
  }

  closeAllIngredients() {
    const ingredientEls = this.querySelectorAll(`[nss-ingredient-item].nss-active`);
    ingredientEls.forEach((ingredientEl) => {
      ingredientEl.classList.remove(`nss-active`);
    });
  }

  updateContent(e) {
    if (this.debug) console.log("[NSS][PDP Ingredients] Updating...");
    const variantId = e.detail;

    const activeEls = this.querySelectorAll(`.nss-active`);
    activeEls.forEach((activeEl) => {
      activeEl.classList.remove(`nss-active`);
    });
    if (this.debug) console.log("[NSS][PDP Ingredients] variantId:", variantId);
    const contentEls = this.querySelectorAll(`[nss-variant-id="${variantId}"]`);
    contentEls.forEach((contentEl) => {
      contentEl.classList.add(`nss-active`);
    });

    // Update color scheme
    const prefix = "nss-scheme-";
    const classes = this.className.split(" ").filter(c => !c.startsWith(prefix));
    this.className = classes.join(" ").trim();
    this.classList.add(`nss-scheme-${variantId}`);
  }
}

let elementName = `nss-pdp-ingredients`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSPDPIngredients);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}